export default __webpack_public_path__ + "static/media/dune_x_crayon_feat_ichon_1.46efef52.png";